import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';

// models
import { IBlogArticle } from '../../../welcome/models/blogArticle';

import { SHARED_MODULES } from '../../../shared.';
import { PhButtonComponent } from '../ph-button/ph-button.component';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';
import { PhLoaderComponent } from '../ph-loader/ph-loader.component';

const AUTO_PLAY_TIME: number = 15 * 1000;

@Component({
    selector: 'app-blog-articles',
    templateUrl: './blog-articles.component.html',
    styleUrls: ['./blog-articles.component.scss'],
	imports: [SHARED_MODULES, PhButtonComponent, PhIconWrapperComponent, PhLoaderComponent],
    standalone: true
})
export class BlogArticlesComponent implements OnInit, OnDestroy {

	articles: Array<IBlogArticle> = [];
	showLoader: boolean = true;
	tabIndex: number = 0;
	timerSubscription: Subscription;

	@Input('articles') set setArticles(value: Array<IBlogArticle>) {
		if (value) {
			this.articles = value;
			this.showLoader = false;
			this.setTimer();
		}
	};

	constructor() {}

	ngOnInit(): void {}

	setTimer(): void {
		if (this.timerSubscription) this.timerSubscription.unsubscribe();
		this.timerSubscription = timer(AUTO_PLAY_TIME).subscribe(() => {
			this.toNextTab();
		});
	}

	toNextTab(): void {
		if (this.tabIndex === this.articles.length - 1) {
			this.tabIndex = 0;
		} else {
			this.tabIndex++;
		}
		this.setTimer();
	}

	toPreviousTab(): void {
		if (this.tabIndex === 0) {
			this.tabIndex = this.articles.length - 1;
		} else {
			this.tabIndex--;
		}
		this.setTimer();
	}

	ngOnDestroy(): void {
		if (this.timerSubscription) this.timerSubscription.unsubscribe();
	}
}
